import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth/auth.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    isloginFormSubmitted = false;

    constructor(private router: Router,
        private formBuilder: FormBuilder,
        private myTitle: Title,
        private snackBar: MatSnackBar,
        private authService: AuthService) {
    }

    ngOnInit() {
        this.myTitle.setTitle('Admin Login | ' + environment.commonTitle);
        this.loginForm = this.formBuilder.group({
            'Email': [null, Validators.required],
            'Password': [null, Validators.required]
        });
    }

    onLoginSubmit() {
        this.isloginFormSubmitted = true;
        if (!this.loginForm.valid) {
            return;
        }
        this.authService.login(this.loginForm.value).subscribe(result => {
            if (result.data) {
                // ---------------------------------
                const userdata = result.data;
                const data = {
                    id: userdata.id,
                    email: userdata.email,
                    username: userdata.username,
                    role: userdata.role
                };
                localStorage.setItem('token', userdata.token);
                localStorage.setItem('member', JSON.stringify(data));
                // ---------------------------------
                this.openSnackBar('Login successfully.', 'Success');
                this.router.navigate(['/secure/home']);
            } else {
                this.openSnackBar('Fail to login !', 'Fail');
            }
        }, error => {
            this.openSnackBar(error.error, 'Fail');
            console.log(error);
        });
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000
        });
    }
}
